<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <b-avatar size="35" variant="light-primary" />
    </template>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="$router.push({ name: 'foravila-account' })"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-2" />
      <span>{{ $t("My account") }}</span>
    </b-dropdown-item>

    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-2" />
      <span>{{ $t("Log out") }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BAvatar } from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
import useBasicAuth from "@/auth/useBasicAuth";
import { $themeConfig } from "@themeConfig";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
  },
  setup() {
    const { appLogoImage } = $themeConfig.app;
    return {
      appLogoImage,
    };
  },
  methods: {
    logout() {
      useBasicAuth.logout();

      // Remove userData from localStorage
      localStorage.removeItem("foravilaOwnersUserData");

      // Reset ability
      this.$ability.update(initialAbility);

      // Reset stores
      this.$store.dispatch("owner/reset");
      this.$store.dispatch("bookingPolicies/reset");
      this.$store.dispatch("providers/reset");
      this.$store.dispatch("services/reset");
      this.$store.dispatch("bookings/reset");
      this.$store.dispatch("accommodation/reset");
      this.$store.dispatch("ui/reset");

      // Redirect to login page
      this.$router.push({ name: "foravila-login" });
    },
  },
};
</script>
